import React from "react";
import clsx from "clsx";

import ScrollSyncPanel from "components/ScrollSync/ScrollSyncPanel/ScrollSyncPanel";
import SurfaceTableHeader from "./SurfaceTableHeader";
import { surfaceTypes } from "../helper";
import useCommonStyles from "../styles";
import useStyles from "./styles";

const TableHeader = () => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const { dirt, turfAndSynthetic } = surfaceTypes;

  return (
    <div className={classes.tableHeader}>
      <div className={commonClasses.leftFixedColumns}>
        <div className={classes.emptyCell} />
        <div className={classes.headerColumns}>
          <div className={clsx(classes.headCell, classes.narrowBorderTop)}>
            Class
          </div>
          <div className={clsx(classes.headCell, classes.narrowBorderTop)}>
            Sub-Class
          </div>
        </div>
      </div>

      <ScrollSyncPanel className={classes.scrollableHeaders}>
        <div>
          <div className={classes.emptyCell} />
          <div className={clsx(classes.headCell, classes.narrowBorderTop)}>
            # of Horses
          </div>
        </div>

        <SurfaceTableHeader surfaceType={dirt.title} />
        <SurfaceTableHeader surfaceType={turfAndSynthetic.title} />
      </ScrollSyncPanel>
    </div>
  );
};

export default TableHeader;
